export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4716.a88b822b.jpg";